import { render, staticRenderFns } from "./CreateAnnotationControl.vue?vue&type=template&id=a88a919e"
import script from "./CreateAnnotationControl.vue?vue&type=script&lang=js"
export * from "./CreateAnnotationControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports